import { Button, Flex, Modal, Typography } from "antd";

import React from "react";
import { CustomTitle } from "../../../../common/customTitle";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteStaffByIdAction } from "../../../../../redux/services/staff/staffServices";
import { useTranslation } from "react-i18next";
import Actions from "../../../../../redux/actions";
import { routes } from "../../../../../constants";
import { baseRouteMaker } from "../../../../../constants/routeConsts";

const CustomerToOrgDialog = () => {
  const userConversionDialog = useSelector(
    (state) => state.auth.userConversionDialog
  );

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  const { t } = useTranslation();

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* initial dependencies */

  /* perform delete action */
  const handleAccept = () => {
    dispatch(Actions.createAction(Actions.USER_CONVERSION_DIALOG_FALSE));
    navigate(baseRouteMaker(routes.PROFILE_SETUP));
  };
  /* perform delete action */

  const handleClose = () => {
    dispatch(Actions.createAction(Actions.USER_CONVERSION_DIALOG_FALSE));
    localStorage.clear();
  };

  return (
    <Modal
      open={userConversionDialog}
      onCancel={handleClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
          {t("confirmationPopup.confirmChange")}
        </CustomTitle>
        <Typography.Paragraph>
          {t("confirmationPopup.customerToOrgDescription")}
        </Typography.Paragraph>
        <Flex gap="1rem" align="center" justify="center">
          <Button type="primary" onClick={handleAccept}>
            {t("confirmationPopup.buttonYesText")}
          </Button>
          <Button type="default" onClick={handleClose}>
            {t("confirmationPopup.buttonNoText")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default CustomerToOrgDialog;
